import React from 'react';
import { Check, ShieldCheck } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-navy-900 relative overflow-hidden scroll-mt-24" data-id="element-109">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full opacity-10 pointer-events-none" data-id="element-110">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold-500 rounded-full blur-3xl" data-id="element-111"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500 rounded-full blur-3xl" data-id="element-112"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-115">
            Tu Futuro Financiero No Debería Costar Una Fortuna
          </h2>
          <p className="text-lg text-slate-300" data-id="element-116">
            Obtén acceso instantáneo a todo el sistema por un único pago. Sin
            mensualidades ocultas.
          </p>
        </div>

        <div className="max-w-lg mx-auto" data-id="element-117">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-gold-500 relative" data-id="element-118">
            {/* Badge */}
            <div className="absolute top-0 right-0 bg-red-500 text-white text-sm font-bold px-4 py-1 rounded-bl-lg" data-id="element-119">
              ¡95% DE DESCUENTO!
            </div>

            <div className="p-8 md:p-10 text-center border-b border-slate-100" data-id="element-120">
              <h3 className="text-2xl font-bold text-navy-900 mb-2" data-id="element-121">
                Acceso Total de Por Vida
              </h3>
              <div className="flex justify-center items-center gap-3 mb-4" data-id="element-122">
                <span className="text-2xl text-slate-400 line-through font-medium" data-id="element-123">
                  $422
                </span>
                <span className="text-5xl font-extrabold text-navy-900" data-id="element-124">
                  $19.99
                </span>
              </div>
              <p className="text-sm text-slate-500 font-medium" data-id="element-125">
                Único pago. Sin suscripciones.
              </p>
            </div>

            <div className="p-8 md:p-10 bg-slate-50" data-id="element-126">
              <ul className="space-y-4 mb-8" data-id="element-127">
                {['Aprende cómo funciona el crédito para usarlo a tu favor', 'Guía de Aprobación de Tarjetas', 'Estrategias para ITIN y SSN', 'Método para borrar deudas médicas y colecciones', 'Estrategia de Crédito de Negocio para obtener capital', 'Acceso inmediato en formato PDF para leer en el celular', 'Actualizaciones gratuitas de por vida'].map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-128">
                    <Check className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-129" />
                    <span className="text-slate-700 font-medium text-left" data-id="element-130">
                      {feature}
                    </span>
                  </li>)}
              </ul>

              <a href="https://www.academyebooks.com/cart/46458086424737:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-8 bg-gold-500 hover:bg-gold-400 text-navy-900 text-xl font-extrabold rounded-xl transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-center" data-id="element-131">
                Obtener Acceso Ahora
              </a>

              <div className="mt-6 flex items-center justify-center gap-2 text-sm text-slate-500" data-id="element-132">
                <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-133" />
                <span data-id="element-134">Garantía de devolución de 30 días</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}